<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="live-duration-list-box">
        <van-sticky>
          <div class="search-box">
            <SearchBar
              @search="search"
              :has-search-btn="true"
              v-model="searchVal"
              placeholder="请输入姓名/手机号查询"
            />
          </div>
          <div class="van-hairline--bottom"></div>
        </van-sticky>
        <van-list
          class="live-duration-container"
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          @load="getList"
        >
          <div class="live-duration-item" v-for="item in list" :key="item.puid">
            <div class="live-duration-item-top">
              <van-image
                round
                :width="transPxToRem(48)"
                :height="transPxToRem(48)"
                :src="item.avatarUrl || 'https://x.jzbull.com/x_dsx_wxadmin/default-head.png'"
              />
              <div class="user-info">
                <div class="user-name">
                  {{ item.nickname }}
                </div>
                <div class="mobile">
                  手机号码：{{ item.mobile }}
                  <span>（ID：{{ item.puid }}）</span>
                </div>
              </div>
            </div>
            <van-divider />
            <div class="live-duration-item-bottom">
              <div class="label-box">
                <van-icon :size="transPxToRem(20)" :name="clockIcon" />
                <span class="label">观看时长</span>
              </div>
              <div>
                {{ item.duration }}
              </div>
            </div>
          </div>
        </van-list>
        <van-empty
          v-if="list.length == 0 && !loading"
          image-size="240"
          image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
          description="暂无观看时长"
        />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, computed, reactive, onMounted } from 'vue'
import { getLiveUserWatchListApi } from '@/api/live'
import { transPxToRem } from '@/utils'
import payIcon from '@/assets/img/pay-icon.png'
import clockIcon from '@/assets/img/clock-icon.png'
import { useRoute } from 'vue-router'
import { SearchBar } from '@/components'
import { useUserStore } from '@/store/user'

const { query } = useRoute()

const userStore = useUserStore()
const userInfo = computed(() => userStore.getUserInfo) //用户信息

const searchVal = ref('')
const search = () => {
  reset()
  getList()
}
const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  finished.value = false
  list.value = []
  pageParams.page = 1
}

const getList = async () => {
  loading.value = true
  try {
    const resData = await getLiveUserWatchListApi({
      puid: userInfo.value.puid,
      roomId: query.roomId,
      keyword: searchVal.value,
      ...pageParams
    })
    const resList = resData.list
    if (resList.length > 0) {
      list.value.push(...resList)
      pageParams.page++
    }
    finished.value = resList.length === 0
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    search()
  } finally {
    refreshing.value = false
  }
}

onMounted(() => {
  search()
})
</script>

<style lang="less" scoped>
@primary-color: #fd6f54;
@font-primary-color: #ff6262;
.page-container {
  overflow: auto;
  .live-duration-list-box {
    padding-bottom: 60px;
    .live-duration-item {
      margin: 12px;
      background-color: white;
      border-radius: 8px;
      padding: 16px;
      .live-duration-item-top {
        display: flex;
        align-items: center;
        .user-info {
          margin-left: 10px;
          .user-name {
            margin-bottom: 4px;
            font-weight: 500;
            font-size: 14px;
          }
          .mobile {
            color: #666666;
            font-size: 13px;
          }
        }
      }
      .live-duration-item-bottom {
        display: flex;
        justify-content: space-between;
        .label-box {
          display: flex;
          align-items: center;
          .label {
            margin-left: 4px;
          }
        }
      }
    }
  }
  .search-box {
    padding: 16px 0;
    background-color: #fff;
  }
}
</style>
